import React, { useEffect, useState } from "react"
import {Container} from "reactstrap"
import ReactDOM from 'react-dom'
import { Amplify } from 'aws-amplify';
import { post } from 'aws-amplify/api';
import amplifyconfig from '../../../amplifyconfiguration.json';
import {Label, FormGroup, Input, FormFeedback} from "reactstrap"
import scrollToElement from "scroll-to-element"
import styled from "styled-components"
import Button from "components/shared/Button"
import Text from "components/shared/Text"
import FormStyled from "components/shared/FormStyled"
import {
		validateRequired,
		validateEmail
} from 'utils/Validations'
import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';

Amplify.configure(amplifyconfig);

const FormFeedbackStyled = styled(FormFeedback)`
	text-align: right;
`

const DropdownButton = styled.div`
	border: 0;
	padding: 0;
	display: block;
	width: 100%;

	svg {
		color: black;
	}
`

const ContactForm = (props) => {
	const { executeRecaptcha } = useGoogleReCaptcha();
	const [values, setValues] = useState(
		{
			name: '',
			telephone: '',
			email: '',
			message: '',
			// googleVerified: '',
		}
	)
	const [validate, setValidate] = useState(
		{
			name: '',
			telephone: '',
			email: '',
			enquiry_type: '',
			message: '',
			// googleVerified: '',
			// googleVerifiedErrMsg: 'Google recaptcha is required'
		}
	)
	const [required, setRequired] = useState(
		{
			name: '',
			enquiry_type: 'General',
			email: '',
		}
	)
	const [enquiryType, setEnquiryType] = useState("General") 
	const [sendTo, setSendTo] = useState("info@mubadalawtc.com") 
	const [sendingFormRequest, setSendingFormRequest] = useState(false) 
	const [success, setSuccess] = useState(false) 
	const form = React.createRef()
	const successMessage = React.createRef()

	useEffect(() => {
		// set enquiry type for first item on load
		changeEnquiryType(props.data.enquiryTypes[0].name, props.data.enquiryTypes[0].email)
	}, [])

	// Method to update field values in state on change
	const handleChange = (e) => {
		const target = e.target
		const name = target.name
		const value = target.value
	
		if (name === "enquiry_type") {
			setSendTo(target.options[target.selectedIndex].getAttribute('data-email'))
		}

		if (required.hasOwnProperty(name)) {
			setRequired(required => ({
				...required,
				[name] : value,
			}))
		}
		setValues(values => ({
			...values,
			[name] : value,
		}))
	}

	const changeEnquiryType = (value, sendTo) => {
		setEnquiryType(value)
		setSendTo(sendTo)
	}

	const handleSubmit = async (e) => {
		e.preventDefault()

		//disable the button so we can't send multiple requests
		setSendingFormRequest(true)

		// Create form data ready for api wrapper call
		const formData = {}
		for (let key in values) {
			formData[key] = values[key]
		}

		formData['send_to'] = sendTo
		formData['enquiry_type'] = enquiryType
		let errors = false

		for (let key in validate) {
			if (required[key] === "" && key !== "googleVerified" && key !== "googleVerifiedErrMsg") {
				validate[key] = 'has-danger'
				errors = true
			}

			setValidate(validate)
		}

		// return if errors
    if (errors) {
      setSendingFormRequest(false)
      return
    }
		// const plainFormData = Object.fromEntries(formData.entries());
		// const formDataJsonString = JSON.stringify(plainFormData);


		// reCAPTCHA check before form submission
		if (!executeRecaptcha) {
			console.log('Execute recaptcha not yet available');
			setSendingFormRequest(false)
			return;
		}	

		// Execute reCAPTCHA and get the token
		const token = await executeRecaptcha('submitForm');

		// Send the token to your API Gateway endpoint
		const recaptchaOperation = post({
			apiName: 'madoContactFormApi',
			path: '/recaptcha',
			options: {
				body: { token },
			}
		});

		const { body: recaptchaBody } = await recaptchaOperation.response;
		const recaptchaResponse = await recaptchaBody.json();

		// recaptcha response failed
		if (!recaptchaResponse.success) { 
			const errorString = 'Please try again';
			alert(errorString)
			setSendingFormRequest(false)
			return;
		}

		const apiName = 'madoContactFormApi'
    const path = '/contact'
    const myInit = {
      body: formData,
    }

		try {
			const restOperation = post({
				apiName: apiName,
				path: path,
				options: myInit
			});

			const { body } = await restOperation.response;
			const response = await body.json();

			setSendingFormRequest(false)

			if (response.result === "success") {
				const domNode = ReactDOM.findDOMNode(successMessage.current)

				setSuccess(true)

				setTimeout(() => {
					scrollToElement(domNode, {
						offset: -120,
						duration: 500
					});
				}, 1000);

				setValues({
					name: '',
					telephone: '',
					email: '',
					message: '',
				})
			}
		} catch (error) {
			setSendingFormRequest(false)
			console.log(error)
		}

		// await fetch('/api/email', {
		// 	method: 'POST',
		// 	redirect: 'follow',
		// 	headers: {
		// 		"Content-Type": "application/json",
		// 		"Accept": "application/json"
		// 	},
		// 	body: formDataJsonString
		// })
		// 	.then(response => {
		// 		console.log(response);
		// 		setSendingFormRequest(false);
		// 		if (response.status === 200) {
		// 			const domNode = ReactDOM.findDOMNode(successMessage.current)

		// 			setSuccess(true)

		// 			scrollToElement(domNode, {
		// 				offset: -120,
		// 				duration: 500
		// 			});
		// 		}
		// 	})
		// 	.catch(error => {
		// 		setSendingFormRequest(false);
		// 		return error.response
		// 	})
	}

	const {data} = props

	if (success) {
		return (
			<Container className="py-4" fluid>
				<div dangerouslySetInnerHTML={{__html: data.thankyouMessage}} ref={successMessage}/>
			</Container>
		)
	} else {
		return (
			<Container className="py-4" fluid>
				<FormStyled onSubmit={(e) => handleSubmit(e)} noValidate ref={form}>
					<FormGroup>
						<Label for="name">{data.nameHeading}<Text as="span" red>*</Text></Label>
						<Input
							type="text"
							name="name"
							id="name"
							className="input-placeholder"
							placeholder={data.namePlaceholder}
							value={values.name}
							valid={validate.name === 'has-success'}
							invalid={validate.name === 'has-danger'}
							onChange={e => {
								handleChange(e)
								setValidate(validateRequired(validate, e))
							}}
						/>
						<FormFeedbackStyled>
							Your name is required
						</FormFeedbackStyled>
					</FormGroup>
					<FormGroup>
						<Label for="enquiry_type">{data.enquiryHeading}<Text as="span" red>*</Text></Label>
						<DropdownButton className="position-relative">
							<Input
								type="select"
								name="enquiry_type"
								id="enquiry_type"
								className="input-placeholder"
								onChange={handleChange}
								value={values.enquiryType}
							>
								{data.enquiryTypes && data.enquiryTypes.map((enquiry, i) => {
									return (
										<option
											key={i}
											value={enquiry.name}
											data-email={enquiry.email}
										>
											{enquiry.name}
										</option>
									)
								})}
							</Input>
							{/* {dropdownOpen ? (
									<FontAwesomeIcon icon={faAngleUp}/>
							) : ( */}
									{/* <FontAwesomeIcon icon={faAngleDown}/> */}
							{/* )} */}
						</DropdownButton>
					</FormGroup>
					<FormGroup>
						<Label for="telephone">{data.telephoneHeading}</Label>
						<Input
							type="text"
							name="telephone"
							id="telephone"
							className="input-placeholder"
							placeholder={data.telephonePlaceholder}
							valid={validate.telephone === 'has-success'}
							invalid={validate.telephone === 'has-danger'}
							value={values.telephone}
							onChange={e => {
								handleChange(e)
							}}
						/>
						<FormFeedbackStyled>
							A valid phone number is required
						</FormFeedbackStyled>
					</FormGroup>
					<FormGroup>
						<Label for="email">{data.emailHeading}<Text as="span" red>*</Text></Label>
						<Input
							type="email"
							name="email"
							className="input-placeholder"
							id="email"
							placeholder={data.emailPlaceholder}
							value={values.email}
							valid={validate.email === 'has-success'}
							invalid={validate.email === 'has-danger'}
							onChange={e => {
								handleChange(e)
								validateRequired(validate, e)
								setValidate(validateEmail(validate, e))
							}}
						/>
						<FormFeedbackStyled>
							A valid email address is required
						</FormFeedbackStyled>
					</FormGroup>
					<FormGroup>
						<Label for="message">{data.messageHeading}</Label>
						<Input
							type="textarea"
							className="input-placeholder"
							name="message"
							id="message"
							value={values.message}
							placeholder={data.messagePlaceholder}
							onChange={e => handleChange(e)}
						/>
					</FormGroup>
					<Text regular>
						<Text as="span" red>*</Text> Required fields<br/>
					</Text>
					<Button 
						as="button" 
						color="main" 
						className="my-3"
						type="submit"
						style={{ pointerEvents: sendingFormRequest ? "none" : "initial" }}
					>
						<span>{data.submitText}</span>
					</Button>
				</FormStyled>
			</Container>
		)
	}
}

export default ContactForm
